import { Flex, IconGearSix, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import {
  CONNECTOR,
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  RuleStack,
  TagsList,
} from 'ui'
import { MoreForLessBenefit } from '../../../../../../../typings'
import { messages } from '../../messages'
import { DistributedTag } from './DistributedTag'
import { EqualsTag } from './EqualsTag'
import { MostExpensiveTag } from './MostExpensiveTag'
import styles from './styles.css'

export type AdvancedConfigProps = {
  config: MoreForLessBenefit['apply']
}
type Props = AdvancedConfigProps & {
  onRemove: () => void
  onEdit: () => void
}

export function AdvancedConfig(props: Props) {
  const { config, onEdit, onRemove } = props
  const {
    benefit: { advanced },
  } = messages
  const { $t } = useIntl()

  return (
    <Rule onClick={onEdit} connector={CONNECTOR.WITH}>
      <RuleIcon>
        <IconGearSix />
      </RuleIcon>
      <RuleDescription>
        {$t(advanced.title, {
          b: (content) => <Text variant="body">{content}</Text>,
        })}
      </RuleDescription>
      <RuleContent>
        <RuleStack>
          <Rule>
            <RuleContent>
              <Flex direction="column" className={styles.advancedContent}>
                <Text variant="detail" tone="secondary">
                  {$t(advanced.allowedProducts, {
                    b: (content) => <Text variant="detail">{content}</Text>,
                  })}
                </Text>
                <TagsList>
                  <EqualsTag config={config} />
                  <MostExpensiveTag config={config} />
                </TagsList>
              </Flex>
            </RuleContent>
          </Rule>
          <Rule connector={CONNECTOR.AND}>
            <RuleContent>
              <Flex direction="column" className={styles.advancedContent}>
                <Text variant="detail" tone="secondary">
                  {$t(advanced.discountDistribution, {
                    b: (content) => <Text variant="detail">{content}</Text>,
                  })}
                </Text>
                <DistributedTag config={config} />
              </Flex>
            </RuleContent>
          </Rule>
        </RuleStack>
      </RuleContent>
      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
